import { Box, IconButton, Typography } from "@mui/material";
import { BasicTableRowStyles, MainContentWrapper, TableHeaderWrapper, TableWrapper } from "../../components/common/Common.styles";
import ServerSideTableColumnHeader from "../../components/common/table/ServerSideTableColumnHeader";
import BorderRow from "../../components/common/table/BorderRow";
import CellBox from "../../components/common/table/CellBox";
import { useServerSidePagination } from "../../hooks/PaginationHooks";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { createNewNotificationThunk, deleteNotificationThunk, fetchInAppNotificationsThunk, updateNotificationThunk } from "../../store/thunk/inAppNotificationsThunk";
import { GenericInAppNotification, GenericInAppNotificationResponse } from "../../types/notificationType";
import { ServerSidePagination } from "../../components/common/table/ServerSidePagination";
import { Edit } from "@mui/icons-material";
import CreateOrEditGenericNotificationDialog from "./CreateOrEditGenericNotificationDialog";
import { useState } from "react";
import SearchBarButtonContainer from "../../components/common/table/SearchBarButtonContainer";
import PageTitle from "../../components/common/PageTitle/PageTitle";
import { useTranslation } from "react-i18next";


export default function GenericInAppNotificationsPage() {
    const { t } = useTranslation();

    const dispatch = useDispatch<AppDispatch>();

    const paginatedData = useServerSidePagination<GenericInAppNotificationResponse>(
        async (paginationParams) => {
            const result = await dispatch(fetchInAppNotificationsThunk(paginationParams));
            if (fetchInAppNotificationsThunk.fulfilled.match(result)) {
                return result.payload;
            }
            return { items: [], totalCount: 0 };
        },
        []
    );

    const [editingNotification, setEditingNotification] = useState<GenericInAppNotificationResponse>();
    const [newNotification, setNewNotification] = useState<boolean>();

    const saveEditedNotification = async (notification: GenericInAppNotification) => {
        await dispatch(updateNotificationThunk(notification))
        paginatedData.updateTableItems();
        setEditingNotification(undefined);
    };

    const deleteEditedNotification = async (notification: GenericInAppNotification) => {
        await dispatch(deleteNotificationThunk(notification))
        paginatedData.updateTableItems();
        setEditingNotification(undefined);
    };

    const saveNewNotification = async (notification: GenericInAppNotification) => {
        await dispatch(createNewNotificationThunk(notification))
        paginatedData.updateTableItems();
        setNewNotification(false);
    };

    return <>
        <PageTitle
            breadcrumbs={[]}
            title={t("genericInAppNotificationsPage.title")}
        />
        <MainContentWrapper>
            <Box style={{ padding: "2em", }}>
                <SearchBarButtonContainer
                    onCreateClick={() => setNewNotification(true)}
                />
            </Box>
            <TableWrapper
                columnsTemplate="1fr 2fr 7rem max-content"
                sx={{ backgroundColor: theme => theme.palette.background.paper }}
            >
                <TableHeaderWrapper>
                    <ServerSideTableColumnHeader
                        isSorted={false}
                        label={t("genericInAppNotificationsPage.columns.title")}
                        firstCol
                        paginatedData={paginatedData}
                    />
                    <ServerSideTableColumnHeader
                        isSorted={false}
                        label={t("genericInAppNotificationsPage.columns.message")}
                        paginatedData={paginatedData}
                    />
                    <ServerSideTableColumnHeader
                        isSorted={false}
                        label={t("genericInAppNotificationsPage.columns.readCount")}
                        paginatedData={paginatedData}
                    />
                    <ServerSideTableColumnHeader
                        isSorted={false}
                        label=""
                        paginatedData={paginatedData}
                        lastCol
                    />
                    <BorderRow />
                </TableHeaderWrapper>
                <Box sx={{ display: "contents" }}>
                    {
                        paginatedData.items.map(n =>
                            <BasicTableRowStyles onClick={() => { }}>
                                <CellBox firstCol stickyFirstCol>
                                    <Typography>{n.title}</Typography>
                                </CellBox>
                                <CellBox>
                                    <Typography>{n.message}</Typography>
                                </CellBox>
                                <CellBox>
                                    <Typography>{n.readCount} / {n.totalCount}</Typography>
                                </CellBox>
                                <CellBox lastCol>
                                    <IconButton onClick={() => setEditingNotification(n)}>
                                        <Edit />
                                    </IconButton>
                                </CellBox>
                            </BasicTableRowStyles>
                        )
                    }
                </Box>
            </TableWrapper>
            <ServerSidePagination paginatedData={paginatedData} />

            {editingNotification && <CreateOrEditGenericNotificationDialog
                onSave={saveEditedNotification}
                onDelete={deleteEditedNotification}
                onClose={() => setEditingNotification(undefined)}
                editingNotification={editingNotification!}
            />}

            {newNotification && <CreateOrEditGenericNotificationDialog
                onSave={saveNewNotification}
                onClose={() => setNewNotification(false)}
            />}
        </MainContentWrapper>
    </>
}